(() => {
  const STORAGE_KEY = 'phaux_newsletter_popup_dismissed_until';
  const SUPPRESS_MS = 30 * 24 * 60 * 60 * 1000; /* 30 days */

  const dialog = document.querySelector('[data-newsletter-popup]');
  if (!dialog) return;

  /* Native <dialog> support check. If unsupported, bail (popup just never shows). */
  if (typeof dialog.showModal !== 'function') return;

  const setDismissed = () => {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now() + SUPPRESS_MS));
    } catch (e) {
      /* localStorage blocked (private mode / iframe). Session-only: do nothing. */
    }
  };

  const isSuppressed = () => {
    try {
      return Date.now() < parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
    } catch (e) {
      return false;
    }
  };

  /* Already shown/dismissed/subscribed within the window: never show again. */
  if (isSuppressed()) return;

  const open = () => {
    if (dialog.open) return;
    dialog.showModal();
    const email = dialog.querySelector('input[type=email]');
    /* Only focus when the field is actually visible (not in the thank-you state). */
    if (email && email.offsetParent !== null) email.focus({ preventScroll: true });
  };

  const close = () => {
    if (dialog.open) dialog.close();
  };

  const form = dialog.querySelector('form');
  const fields = dialog.querySelector('[data-popup-form-fields]');
  const success = dialog.querySelector('[data-popup-success]');

  if (form) {
    /*
     * Submit into a hidden iframe.
     *
     * The store has reCAPTCHA enabled on customer forms, so the submit must be
     * NATIVE for Shopify to attach the CAPTCHA token - an AJAX fetch is rejected
     * with 400 "Missing CAPTCHA token". Targeting a hidden iframe keeps the
     * native submit (and the token, and the customer record) but stops the main
     * page from navigating, so we can show an inline thank-you instead of a full
     * page reload + reopen.
     */
    /* The iframe MUST live inside the dialog. While the popup is open via
       showModal(), everything outside it (including <body>) is inert, and a form
       cannot post to an iframe that sits in an inert subtree - so a body-level
       iframe silently swallowed the submit. The dialog's own subtree stays in
       the top layer and interactive, so an iframe here receives the post. */
    let sink = dialog.querySelector('iframe[name="phaux-newsletter-sink-popup"]');
    if (!sink) {
      sink = document.createElement('iframe');
      sink.name = 'phaux-newsletter-sink-popup';
      sink.setAttribute('aria-hidden', 'true');
      sink.tabIndex = -1;
      sink.style.display = 'none';
      dialog.appendChild(sink);
    }
    form.setAttribute('target', 'phaux-newsletter-sink-popup');

    form.addEventListener('submit', () => {
      /* Show the thank-you immediately, close after 3s, and never show the popup
         again - regardless of the response. Do NOT preventDefault: the native
         submit posts to the hidden iframe so reCAPTCHA still runs. */
      if (fields) fields.hidden = true;
      if (success) success.hidden = false;
      setDismissed();
      setTimeout(close, 3000);
    });
  }

  /* Schedule first show. */
  const delaySec = parseInt(dialog.dataset.delaySeconds || '5', 10);
  setTimeout(open, delaySec * 1000);

  /* Close affordances: X, backdrop click. ESC is handled natively by showModal(). */
  const closeBtn = dialog.querySelector('[data-popup-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) close();
  });

  /* Any close path suppresses the popup for 30 days. */
  dialog.addEventListener('close', setDismissed);
})();
